import { Link } from "@inertiajs/react";
import { ArrowRight, Coins } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { bizminer_admin_organization_credits_path } from "@/routes";

interface Props {
  organizationId: number;
  balance: number;
  spentThisMonth: number;
}

// File-local components

interface BalanceDisplayProps {
  balance: number;
}

const BalanceDisplay = ({ balance }: BalanceDisplayProps) => (
  <div className="flex items-start justify-between">
    <div className="flex items-center gap-3">
      <div className="p-2 bg-primary/10 rounded-lg">
        <Coins className="h-6 w-6 text-primary" />
      </div>
      <div>
        <p className="text-sm font-medium text-muted-foreground">
          Credit Balance
        </p>
        <p className="text-3xl font-bold text-foreground mt-1">
          {balance.toLocaleString()}
        </p>
      </div>
    </div>
    <ArrowRight className="h-5 w-5 text-muted-foreground" />
  </div>
);

// Main component

export default function CreditBalanceCard({ organizationId, balance }: Props) {
  return (
    <Link href={bizminer_admin_organization_credits_path(organizationId)}>
      <Card className="hover:shadow-md transition-shadow cursor-pointer">
        <CardContent>
          <BalanceDisplay balance={balance} />
        </CardContent>
      </Card>
    </Link>
  );
}
